import React from 'react'
import { Form, FormControlProps } from 'rsuite'
import FormTextareaControl from '../form/FormTextareaControl'

type LocalizedFormItemProps = {
  selectedLanguage: string
  name: string
  label?: string
  value: string
  type?: 'input' | 'textarea'
  onChange: (value: string) => void
  rows?: number
}

const LocalizedForm: React.FC<FormControlProps & LocalizedFormItemProps> = ({
  selectedLanguage,
  name,
  label,
  value,
  type = 'input',
  rows = 5,
  onChange,
  ...props
}) => {

  if (type === 'textarea') {
    return (
      <Form.Group>
        { label && <Form.ControlLabel>{ label }</Form.ControlLabel> }
        <FormTextareaControl
          {...props}
          rows={rows}
          name={`${name}_${selectedLanguage}`} 
          placeholder={`${label} на ${selectedLanguage}`} 
          value={value}
          onChange={onChange}
        />
      </Form.Group>
    )
  }

  return (
    <Form.Group>
      { label && <Form.ControlLabel>{ label }</Form.ControlLabel> }
      <Form.Control 
        {...props}
        name={`${name}_${selectedLanguage}`} 
        placeholder={`${label} на ${selectedLanguage}`} 
        value={value}
        onChange={onChange}
      />
    </Form.Group>
  )
}

export default LocalizedForm